import ExcelJS from 'exceljs';

export const downloadPlanilha = async (eap, cpu, insumos, moedas, name) => {
  const workbook = new ExcelJS.Workbook();

  const worksheetEap = workbook.addWorksheet('EAP');
  worksheetEap.columns = [
    { header: 'CHECK', key: 'check', width: 10 },
    { header: 'ITEM', key: 'item', width: 20 },
    { header: 'COD. CPU', key: 'codigoCpu', width: 10 },
    { header: 'DESCRIÇÃO DO ITEM', key: 'descricaoItem', width: 25 },
    { header: 'UNIDADE', key: 'unidade', width: 10 },
    { header: 'QUANTIDADE', key: 'quantidade', width: 13 },
    { header: 'CUSTO UNITÁRIO', key: 'custoUnitario', width: 15 },
    { header: 'CUSTO TOTAL', key: 'custoTotal', width: 15 }
  ];
  eap.forEach(element => {
    const linha = {
      check: element.check,
      item: element.item,
      codigoCpu: element.codigoCpu,
      descricaoItem: element.descricaoItem,
      unidade: element.unidade,
      quantidade: element.quantidade,
      custoUnitario: element.custoUnitario.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      custoTotal: element.custoTotal.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })
    };
    worksheetEap.addRow(linha);
  });

  const worksheetCpu = workbook.addWorksheet('CPU');
  worksheetCpu.columns = [
    { header: 'COD. COMP.', key: 'codComp', width: 10 },
    { header: 'COD. INS.', key: 'codIns', width: 12 },
    { header: 'INDICE', key: 'indice', width: 10 },
    { header: 'CUSTO', key: 'custo', width: 17 },
  ];
  cpu.forEach(element => {
    const linha = {
      codComp: element.cpuId,
      codIns: element.insumoId,
      indice: element.indice,
      custo: element.custo.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })
    };
    worksheetCpu.addRow(linha);
  });

  const worksheetInsumos = workbook.addWorksheet('INSUMOS');
  worksheetInsumos.columns = [
    { header: 'CATEGORIA', key: 'categoria', width: 12 },
    { header: 'CÓDIGO', key: 'codigo', width: 13 },
    { header: 'DESCRIÇÃO', key: 'descricao', width: 30 },
    { header: 'UNIDADE', key: 'unidade', width: 13 },
    { header: 'MOEDA', key: 'moeda', width: 9 },
    { header: 'CUSTO', key: 'custo', width: 15 },
    { header: 'CUSTO CONVERTIDO', key: 'custoConvertido', width: 20 },
  ];
  insumos.forEach(element => {
    const linha = {
      categoria: element.categoria,
      codigo: element.insumoId,
      descricao: element.descricao,
      unidade: element.unidade,
      moeda: element.moeda,
      custo: element.custo.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      custoConvertido: element.custoConvertido.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })
    };
    worksheetInsumos.addRow(linha)
  });

  const worksheetMoedas = workbook.addWorksheet('MOEDAS');
  worksheetMoedas.columns = [
    { header: 'MOEDA', key: 'moeda', width: 10 },
    { header: 'DESCRIÇÃO', key: 'descricao', width: 17 },
    { header: 'PETAX', key: 'petax', width: 10 },
  ];
  moedas.forEach(element => {
    const linha = {
      moeda: element.moeda,
      descricao: element.descricao,
      petax: element.petax.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })
    }
    worksheetMoedas.addRow(linha)
  })

  const buffer = await workbook.xlsx.writeBuffer().then(buffer => buffer);
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${name}.xlsx`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
